module.exports = __webpack_public_path__ + "img/panelView_blackBg_3_1.f4139053.png";